/**
 * Feature Flags Configuration
 * 
 * Centralized feature flag management for the application.
 * All flags are active by default unless explicitly disabled via environment variables.
 */

const FEATURES = {
  /**
   * Quick Start onboarding flow for new users
   * - Triggers after login if user needs BGG ID, collection, or session setup
   * - 3-screen modal wizard: BGG Import → Manual Add → Session Logging
   */
  QUICK_START_ENABLED: process.env.REACT_APP_FEATURE_QUICK_START !== 'false',

  /**
   * RAG Chatbot floating action button
   * - Shows the app assistant button in the bottom-right corner
   * - Hidden when disabled, but the ChatbotProvider/Sidebar remain mounted
   */
  CHATBOT_ENABLED: process.env.REACT_APP_FEATURE_CHATBOT !== 'false',
};

/**
 * Check if a specific feature is enabled
 * @param {string} featureName - Key from FEATURES object
 * @returns {boolean}
 */
export function isFeatureEnabled(featureName) {
  return FEATURES[featureName] ?? false;
}

/**
 * Get all feature flags (for debugging/admin)
 * @returns {Object}
 */
export function getAllFeatures() {
  return { ...FEATURES };
}

export default FEATURES;
